export const environment = {
  production: false,
  database: {
    apiKey: "AIzaSyBmfb5lbJ29AdVQyp0Jk1Tug6pekx_fTwA",
    authDomain: "pq2-staging.firebaseapp.com",
    databaseURL: "https://pq2-staging.firebaseio.com",
    projectId: "pq2-staging",
    storageBucket: "pq2-staging.appspot.com",
    messagingSenderId: "438992683153"
  },
  pubQueueApiUrl: "https://us-central1-pq2-staging.cloudfunctions.net",
  primeApiUrl: "https://us-central1-joboffice-prime-staging.cloudfunctions.net",
};


